import { useCallback, ChangeEvent } from "react";

import { Icon, SearchSVG, type SvgComponentType } from "@newsela/angelou";
import { debounce } from "@s-libs/micro-dash";

import { useStandardsSearchContext } from "@/search/NewSearchPageMVP/provider/StandardsSearchProvider";
import {
  rootCss,
  iconCss,
  rootCssWithBorder,
  createStandardInputcss,
  labelTextCss,
  labelCss,
} from "./StandardsModalSearchInput.styles";

interface IStandardsModalSearchInput {
  isCreateStandardMode?: boolean;
}

const StandardsModalSearchInput = ({
  isCreateStandardMode = false,
}: IStandardsModalSearchInput) => {
  const { isLoadingStandardsResults, handleStandardsSearch } =
    useStandardsSearchContext();

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const needle = e.target.value;
    handleStandardsSearch(needle);
  };

  const debouncedOnChange = useCallback(debounce(onChange, 1000), []);

  return (
    <div css={isCreateStandardMode ? rootCss : rootCssWithBorder}>
      <Icon
        SvgComponent={SearchSVG as SvgComponentType}
        __cssFor={iconCss(isCreateStandardMode)}
      />
      <label
        data-testid="standards-modal-search-input"
        htmlFor="standards-modal-search-input"
        css={labelCss(isCreateStandardMode)}
      >
        <span css={labelTextCss}>Search by Standard Code</span>
        <input
          id="standards-modal-search-input"
          data-qa-selector="standards-modal-search-input-create-set"
          data-testid="standards-modal-search-input-create-set"
          onChange={(e) => debouncedOnChange(e)}
          css={createStandardInputcss}
          placeholder="Standard code"
          disabled={isLoadingStandardsResults}
        />
      </label>
    </div>
  );
};

export { StandardsModalSearchInput };
